import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import SplashFooter from "../common/footer/SplashFooter";
import SplashHeader from "../common/header/SplashHeader";
import SEO from "../common/SEO";
import SplashBanner from "../component/banner/SplashBanner";
import ModernBanner from "../component/banner/ModernBanner";
import SplashCta from "../component/cta/SplashCta";
import ColorSwitcher from "../elements/switcher/ColorSwitcher";
import SplashData from "../data/splash/SplashData.json";
import { slugify } from "../utils";
import { FaAngleRight } from "react-icons/fa";
import DarkCardsLists from "../component/DarkCardsList";
import { useTranslation } from "react-i18next";
import BlogGridOne from "../component/blog/BlogGridOne";
import ModernBlogGrid from "../component/blog/ModernBlogGrid";
import BlogSidebar from "../component/blog/BlogSidebar";
import CardsLists from "../component/CardsLists";
import ModernCards from "../component/ModernCards";
import AppHomeMobileButton from "../component/AppHomeMobileButton";
import HeaderFour from "../common/header/HeaderFour";
import HeaderOne from "../common/header/HeaderOne";
import { logPageView } from "../services/analytics";
import ModernLoader from "../component/loader/ModernLoader";

const DemoData = SplashData[0];
const FeatureData = SplashData[1];

const viewStates = {
  showCertificateInput: "showCertificateInput",
};
const Splash = () => {
  const { t } = useTranslation();
  const [viewState, setViewState] = useState({
    state: null,
  });
  const [isLoading, setIsLoading] = useState(true);

  // Controlar el loader y registrar pageview
  useEffect(() => {
    // Simular carga de recursos
    const timer = setTimeout(() => {
      setIsLoading(false);
      logPageView(window.location.pathname, 'Gestión Ciudad - Inicio');
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <ModernLoader isLoading={isLoading} />
      <SEO title="Gestión Ciudad" />
      <ColorSwitcher />
      <main className="main-wrapper">
        <HeaderOne />
        <ModernBanner />

        <AppHomeMobileButton style={{ marginTop: "20px" }} />
        
        {/* Modal de certificados */}
        <div
          style={{
            zIndex: 3,
            position: "relative",
          }}
        >
          {viewState.showCertificateInput && (
            <div
              className="dialog-overlay"
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 9999,
              }}
            >
              <div
                className="dialog-content"
                style={{
                  backgroundColor: "#fff",
                  padding: "20px",
                  borderRadius: "8px",
                  boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
                }}
              >
                <div className="dialog-header" style={{ textAlign: "center" }}>
                  <img
                    src={process.env.PUBLIC_URL + "/images/icon/icon-36.png"}
                    alt="Logo"
                    style={{
                      maxWidth: "100%",
                      height: "auto",
                      marginBottom: "20px",
                    }}
                  />
                  <h4>Descargar Certificado</h4>
                </div>
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    // open new window to /certificate/validation/${document.getElementById("certificateNumber").value}
                    window.open(
                      `/certificate/validation/${
                        document.getElementById("certificateNumber").value
                      }?register_id=${
                        document.getElementById("register_number").value
                      }`,
                      "_blank"
                    );
                  }}
                >
                  <div className="form-group">
                    <label htmlFor="certificateNumber">
                      Número de certificado
                    </label>
                    <input
                      type="text"
                      id="certificateNumber"
                      placeholder="Ingrese número de certificado"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="register_number">Número de registro</label>
                    <input
                      type="text"
                      id="register_number"
                      placeholder="Ingrese número de registro"
                    />
                  </div>
                  <div
                    style={{
                      marginTop: "20px",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <button
                      type="button"
                      className="btn btn-danger btn-lg"
                      onClick={() =>
                        setViewState({ showCertificateInput: false })
                      }
                    >
                      Cancelar
                    </button>
                    <button
                      type="submit"
                      className="btn btn-lg btn-success"
                      style={{}}
                    >
                      Enviar
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}
          <ModernCards
            title={
              window["configSite"]
                ? window["configSite"]["siteName"]
                : t("Servicios Digitales")
            }
            subtitle={
              window["configSite"]
                ? window["configSite"]["siteDescription"]
                : t("Soluciones integrales para modernizar tu gestión pública")
            }
            data={[
              {
                id: 1,
                title: "Trámites en Línea",
                icon: "/images/icon/icon-37.png",
                para: "Realiza tus trámites de forma rápida y sencilla desde cualquier lugar, 24/7.",
                onClick: () => {
                  // Handle click event
                },
                href: "/procedures",
              },
              {
                id: 2,
                title: "Certificados Digitales",
                icon: "/images/icon/icon-38.png",
                para: "Obtén y valida certificados oficiales de forma instantánea y segura.",
                onClick: () => {
                  // Handle click event
                  setViewState((prev) => ({
                    ...prev,
                    showCertificateInput: true,
                  }));
                },
              },
              {
                id: 3,
                title: "Pagos en Línea",
                icon: "/images/icon/icon-32.png",
                para: "Realiza tus pagos de manera segura con múltiples métodos de pago.",
                onClick: () => {
                  // Handle click event
                },
              },
              {
                id: 4,
                title: "Documentación en Línea",
                icon: "/images/icon/icon-24.png",
                para: "Accede a guías completas y documentación paso a paso para cada trámite.",
                onClick: () => {
                  // Handle click event
                },
              },
              {
                id: 5,
                disabled: true,
                title: "Soporte Premium",
                icon: "/images/icon/icon-22.png",
                para: "Atención personalizada para resolver todas tus dudas e inquietudes.",
                onClick: () => {
                  // Handle click event
                },
              },
            ]}
          />
        </div>
        
        {/* Sección de Blog Moderno */}
        <div className="section section-padding-equal bg-color-light" style={{ padding: '80px 0' }}>
          <div className="container">
            <div className="section-heading heading-left mb--40">
              <span className="subtitle">Blog</span>
              <h2 className="title mb--0">Últimas Noticias y Publicaciones</h2>
            </div>
            <div className="row">
              <div className="col-lg-8">
                <BlogGridOne />
              </div>
              <div className="col-lg-4">
                <BlogSidebar />
              </div>
            </div>
          </div>
        </div>
        
        {/* CTA y Footer */}
        <SplashCta />
        <SplashFooter />
      </main>
    </>
  );
};

export default Splash;
